export var SearchItemRole = /*#__PURE__*/function (SearchItemRole) {
  SearchItemRole["Caption"] = "caption";
  return SearchItemRole;
}({});
// #sourceMappingURL=types.js.map